import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useTheme } from '@/context/ThemeContext';
import { Link } from 'react-router-dom';
import { ArrowRight, MessageCircle } from 'lucide-react';

export default function CTAFinal() {
  const { theme } = useTheme();
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-100px' });
  const waLink = 'https://wa.me/6281999934451?text=Halo%20Bewhy,%20saya%20ingin%20jadwalkan%20Sesi%20Discovery';

  return (
    <section
      data-testid="cta-final-section"
      ref={ref}
      className="relative overflow-hidden"
      style={{ backgroundColor: 'var(--bg-primary)' }}
    >
      {/* Background gradient */}
      <div className="absolute inset-0 pointer-events-none">
        <div
          className="absolute w-[800px] h-[800px] rounded-full blur-[200px] opacity-10"
          style={{
            background: 'var(--accent-primary)',
            top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
          }}
        />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-8 py-24 md:py-32 lg:py-40 text-center">
        <motion.span
          className="font-mono text-xs tracking-[0.2em] uppercase block mb-6"
          style={{ color: 'var(--accent-primary)' }}
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
        >
          Let's Build Something Meaningful
        </motion.span>

        <motion.h2
          className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold tracking-tighter leading-tight mb-6"
          style={{ color: 'var(--text-primary)' }}
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ delay: 0.1 }}
        >
          Siap menemukan <span style={{ color: 'var(--accent-primary)' }}>'Why'</span> bisnis Anda?
        </motion.h2>

        <motion.p
          className="text-base md:text-lg leading-relaxed max-w-2xl mx-auto mb-10"
          style={{ color: 'var(--text-secondary)' }}
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ delay: 0.2 }}
        >
          {theme === 'dark'
            ? 'Mulai dari percakapan. Tidak ada pitch deck, tidak ada proposal template. Hanya dialog jujur tentang tujuan bisnis Anda.'
            : 'Jadwalkan sesi discovery 30 menit. Gratis, tanpa komitmen. Kami akan membantu Anda melihat potensi digital bisnis Anda dengan lebih jernih.'}
        </motion.p>

        <motion.div
          className="flex flex-wrap justify-center gap-4"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ delay: 0.3 }}
        >
          <Link
            to="/tanya-bewhy"
            data-testid="cta-final-discovery"
            className="group inline-flex items-center gap-2 px-10 py-5 rounded-full font-heading font-semibold text-sm tracking-wide uppercase transition-all duration-300 hover:-translate-y-1"
            style={{
              backgroundColor: 'var(--accent-primary)',
              color: theme === 'dark' ? '#0D0D0D' : '#FFFFFF',
              boxShadow: `0 0 40px ${theme === 'dark' ? 'rgba(0,255,133,0.3)' : 'rgba(13,148,136,0.3)'}`,
            }}
          >
            Jadwalkan Sesi Discovery
            <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
          </Link>

          <a
            href={waLink}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-final-whatsapp"
            className="inline-flex items-center gap-2 px-10 py-5 rounded-full font-heading font-semibold text-sm tracking-wide uppercase transition-all duration-300 hover:-translate-y-1"
            style={{
              border: '1px solid var(--border-card)',
              color: 'var(--text-primary)',
            }}
          >
            <MessageCircle size={16} />
            Chat via WhatsApp
          </a>
        </motion.div>
      </div>
    </section>
  );
}
